(() => {
  function init(root) {
    root.querySelectorAll('[data-frost-product]').forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const gallery = product.querySelector('[data-gallery]');
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === current)); });
        gallery.querySelector('[data-gallery-count]').textContent = `${current + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      });
      const currency = product.dataset.currency || 'USD';
      const format = value => new Intl.NumberFormat(product.dataset.locale || 'en-US', {style: 'currency', currency}).format(value / 100);
      const price = Number(product.dataset.price);
      const reference = Number(product.dataset.reference) || price;
      const form = product.querySelector('.fs-product-form');
      const protection = product.querySelector('[data-protection-id]');
      const subtotal = product.querySelector('[data-items-subtotal]');
      const updateSubtotal = () => {
        const input = product.querySelector('.fs-offers input:checked');
        const total = Number(input?.dataset.total) || price * Number(input?.dataset.paid || 1);
        const extra = protection?.checked ? Number(protection.dataset.protectionPrice) || 0 : 0;
        if (subtotal) subtotal.textContent = format(total + extra);
        document.querySelectorAll('[data-sticky-price]').forEach(el => { el.textContent = format(total + extra); });
      };
      protection?.addEventListener('change', updateSubtotal);
      product.querySelectorAll('.fs-offers input').forEach(input => input.addEventListener('change', () => {
        if (!input.checked) return;
        const total = Number(input.dataset.total) || price * Number(input.dataset.paid);
        const full = Number(input.dataset.full) || reference * Number(input.value);
        const saving = full - total;
        product.querySelector('[data-offer-total]').textContent = format(total);
        const crossed = product.querySelector('[data-offer-reference]');
        crossed.hidden = saving <= 0;
        crossed.textContent = format(full);
        const label = product.querySelector('[data-offer-saving]');
        label.hidden = saving <= 0;
        label.textContent = saving > 0 ? (input.dataset.savingLabel || `${product.dataset.saveLabel} ${Math.round(saving / full * 100)}%`) : '';
        updateSubtotal();
      }));
      const sticky = document.querySelector('[data-frost-sticky]');
      const reviews = product.querySelector('[data-inline-reviews]');
      if (reviews) {
        const reviewSlides = [...reviews.querySelectorAll('[data-review-slide]')];
        const reviewDots = [...reviews.querySelectorAll('[data-review-dot]')];
        let activeReview = 0;
        const showReview = index => {
          activeReview = (index + reviewSlides.length) % reviewSlides.length;
          reviewSlides.forEach((slide, i) => { slide.hidden = i !== activeReview; });
          reviewDots.forEach((dot, i) => { dot.setAttribute('aria-pressed', String(i === activeReview)); });
        };
        const dotGroup = reviews.querySelector('[data-review-dots]');
        if (dotGroup) dotGroup.hidden = false;
        reviewDots.forEach((dot, index) => dot.addEventListener('click', () => showReview(index)));
        reviews.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            showReview(activeReview + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        let swipeStart;
        reviews.addEventListener('pointerdown', event => {
          if (event.isPrimary) swipeStart = {x: event.clientX, y: event.clientY};
        }, {passive: true});
        reviews.addEventListener('pointerup', event => {
          if (!swipeStart || !event.isPrimary) return;
          const dx = event.clientX - swipeStart.x;
          const dy = event.clientY - swipeStart.y;
          swipeStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showReview(activeReview + (dx < 0 ? 1 : -1));
        }, {passive: true});
        reviews.addEventListener('pointercancel', () => { swipeStart = null; }, {passive: true});
        reviews.addEventListener('shopify:block:select', event => {
          const index = reviewSlides.findIndex(slide => slide.dataset.reviewBlockId === event.detail.blockId);
          if (index >= 0) showReview(index);
        });
      }
      const atc = product.querySelector('.fs-atc');

      if (protection) protection.disabled = false;
      updateSubtotal();
      form?.addEventListener('submit', async event => {
        if (!protection?.checked || form.hasAttribute('data-preview-form')) return;
        event.preventDefault();
        if (atc.disabled) return;
        const error = product.querySelector('[data-cart-error]');
        error.hidden = true;
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
        const quantity = Number(form.querySelector('input[name="quantity"]:checked')?.value || 1);
        const id = Number(form.querySelector('input[name="id"]').value);
        try {
          const cartResponse = await fetch(`${product.dataset.cartUrl}.js`, {headers: {'Accept': 'application/json'}});
          if (!cartResponse.ok) throw new Error(product.dataset.cartErrorLabel);
          const cart = await cartResponse.json();
          const protectionId = Number(protection.dataset.protectionId);
          const items = [{id, quantity}];
          if (!cart.items.some(item => item.variant_id === protectionId)) items.unshift({id: protectionId, quantity: 1});
          const response = await fetch(`${product.dataset.cartAdd}.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || product.dataset.cartErrorLabel);
          window.location.assign(product.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || product.dataset.cartErrorLabel;
          error.hidden = false;
          atc.disabled = false;
          atc.removeAttribute('aria-busy');
        }
      });
      if (sticky && atc && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold: 0});
        observer.observe(atc);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
